import { Component, ElementRef, OnInit, ViewChild, Inject, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { EventService } from 'src/app/services/event.service';
import { StorageService } from 'src/app/services/storage.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { checkoutAddress } from 'src/app/models/user-data.models';
import { MapsService } from 'src/app/services/maps.service';
import endpoints from 'src/app/helpers/endpoints';
import { HttpResponse } from '@angular/common/http';
import { CustomerDashboardService } from 'src/app/pages/customer-dashboard/services/customer-dashboard.service';

@Component({
  selector: 'fury-change-address',
  templateUrl: './change-address.component.html',
  styleUrls: ['./change-address.component.scss']
})
export class ChangeAddressComponent implements OnInit, OnDestroy, AfterViewInit {

  addressForm !: FormGroup;
  @ViewChild('address', { static: false }) public address!: ElementRef;
  subs: Subscription[] = [];
  ngUnsubscribe =  new Subject<void>();
  isCoverState!: boolean;
  showZipCodeField = false;
  allStates: any[] = [];

  constructor(
    public apiService: ApiService,
    public event: EventService,
    private mapService: MapsService,
    private storage: StorageService,
    @Inject(MAT_DIALOG_DATA) public data: checkoutAddress,
    public dialogRef: MatDialogRef<ChangeAddressComponent>,
    private cdr: ChangeDetectorRef,
    private customerDashboardService: CustomerDashboardService
    ) { }

  ngOnInit(): void {
    this.formInit();
    this.getAllstate();
    if (this.data) this.addressForm.patchValue(this.data);
    this.addressForm.get('address')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: string)=>{
      if(!res){
        this.addressForm.patchValue({
          state: '',
          city: '',
          zip: ''
        })
      }
    });
  };
  formInit(){
    this.addressForm = new FormGroup({
      address: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      zip: new FormControl('', [Validators.required]),
      unitNumber: new FormControl('')
    })
  };
  ngAfterViewInit() {
    if (this.address) { this.mapService.autoFillLocation(this.address, 'checkoutAddress'); }
      this.mapService.getaddressEvent.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
        if (res && typeof res === 'object' && res.root === 'checkoutAddress') {
          this.addressForm.patchValue(res);
          this.addressForm.get('zip').setValue(res.zipcode);
          if(res.state) {
            setTimeout(()=>{
              this.checkCoverState(res.state);
            }, 0)
          }
          if(res.zipcode){
            this.showZipCodeField = false;
          } else {
            this.showZipCodeField = true;
          }
        }
      })
  };
  updateAddress(){
    if(!this.addressForm.value.zip) {
      this.showZipCodeField = true;
      return;
    }
    if(this.addressForm.valid){
      this.dialogRef.close(this.addressForm.value);
    } else {
      this.addressForm.markAllAsTouched();
    }
  };
  close(){
    this.addressForm.reset();
    this.dialogRef.close();
  };
  checkCoverState(state: string){
   this.isCoverState = this.checkCoveredStates(state);
   if(!this.isCoverState) {
    this.addressForm.controls['address'].setErrors({ notCovered: true });
   }
   this.cdr.detectChanges();
  };
  checkZipCode() {
    this.apiService
      .getCityState(this.addressForm.controls['zip'])
      .then((data) => {
        if (data) {
          this.addressForm.patchValue(data);
          if(data.state) this.checkCoverState(data.state);
        } else {
          this.addressForm.controls['zip'].setErrors({ notValid: true });
        }
      });
  }
  getAllstate(){
   this.customerDashboardService.getAllStates$.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
    next: (res : any[])=>{
      this.allStates = res;
    }
   })
  }
  checkCoveredStates(state: string): boolean {
    if(this.allStates.length > 0){
      const x = this.allStates.find(sta => sta.title.toLowerCase() === state.toLowerCase());
      return (x && (x.type === 'covered'));
    }
   return false;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
